// Default search values for the donations table
export const searchValues = {
  id: "",
  isPaid: "",
  toDate: new Date(new Date().setHours(23, 59, 59, 999)),
  toAmount: "",
  fromDate: new Date(new Date().setHours(0, 0, 0, 0)),
  fromAmount: "",
  phoneNumber: "",
  paymentType: "",
  orderStatus: "",
  orderType: "0",
  clientId: "",
};

// Mapping of Excel header cells to their corresponding field names
export const excelHeaderCellsName = {
  المعرف: "id",
  مدفوع: "isPaid",
  ملاحظات: "notes",
  "اسم المستخدم": "userName",
  "نوع الدفع": "paymentType",
  // "رقم الهاتف": "phoneNumber",
  "حالة الطلب": "orderStatus",
  "تاريخ التبرع": "donationDate",
  "المبلغ الإجمالي": "totalAmount",
  "رابط التحويل البنكي": "bankTransferFullUrl",
};

// Options for the order status dropdown
export const orderStatusOptions = [
  { name: "مؤكد", value: 0 },
  { name: "مرفوض", value: 3 },
  { name: " غير مؤكد", value: 1 },
  { name: " يحتاج موافقة", value: 2 },
];

// options for order type
export const orderTypeOptions = [
  { name: "متجر الجمعية", value: 0 },
  { name: "صفحة التبرع السريع", value: 1 },
];

// Options for bank transfer edit table
export const editBankTransferTableColumns = [
  "اسم المشروع",
  "نوع التبرع",
  "الكمية",
  "سعر الوحدة",
  "المبلغ",
];
